<!-- <template>    
  <v-card class="ma-4 pa-4">
    <v-card-title class="text-h5">Informe</v-card-title>
    <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>
    <v-card-text>

      <v-row>


        <v-col cols="12">


        <v-row align="center" class="mb-4">
          <v-col cols="4">
            <VueDatePicker 
                  model-type="dd/MM/yyyy" 
                  v-model="fecha_inicio" 
                  :format="'dd/MM/yyyy'" text-input             
                  :teleport="true"                
                  />
          </v-col>
          <v-col cols="4">
              <VueDatePicker 
                  model-type="dd/MM/yyyy" 
                  v-model="fecha_fin" 
                  :format="'dd/MM/yyyy'" text-input             
                  :teleport="true"                
                  />
          </v-col>
          <v-col cols="4">
            <v-btn color="primary" @click="obtener_datos()">Filtrar</v-btn>
          </v-col>
        </v-row>
        
          <v-row>
            <v-col cols="12">
              <div id="app2">
                <v-grid 
                  :disabled="false"
                  theme="material" 
                  :source="data" 
                  :columns="headers"
                  canFocus=true
                  range=true
                  useClipboard=true
                  filter=true
                  resize=true                
                ></v-grid>      
              </div>
            </v-col>      
          </v-row>
        
        </v-col>


        
        <v-col cols="6">
          <v-row align="center" class="mb-4">
            
              <v-col cols="12">
                <v-select
                  v-model="selectedVariables"
                  :items="variableOptions"
                  label="Variables"
                  multiple
                ></v-select>
                <v-select
                  v-model="chartType"
                  :items="chartTypes"
                  label="Tipo de gráfico"
                ></v-select>
              </v-col>
          </v-row>

            
          <v-row align="center" class="mb-4">
            <v-col cols="12">
              <div ref="chart" style="width: 100%; height: 400px;"></div>
            </v-col>
          </v-row>
        </v-col>
        

      </v-row>


    </v-card-text>
  </v-card>
</template> -->
<template>
  <div></div>
</template>

<script>
/*
import VGrid from "@revolist/vue3-datagrid";
import ComponenteLoading from '../ComponenteLoading.vue';
import store from '../../store';
import axios from 'axios';
//import * as echarts from "echarts";
export default {
  components: {
    VGrid,
    ComponenteLoading,
  },
  data() {
    return {

        loading: false,
        mensaje_loading: "",

      fecha_inicio: "03/03/2025",
      fecha_fin: "10/03/2025",
      data: [],
      headers: [],
      

      selectedVariables: ["PCIO_EL"],
      variableOptions: ["PCIO_EL", "COST_GMCMC", "COST_CONTEL", "DEMV"],
      chartType: "line",
      chartTypes: ["line", "bar", "histogram", "scatter"],
      chart: null,


    };
  },

  watch: {
    selectedVariables: "updateChart",
    chartType: "updateChart",
  },
  mounted() {
    //this.chart = echarts.init(this.$refs.chart);
    //this.updateChart();
  },


  methods: {
    
    obtener_datos(){
        

          this.loading = true;
          this.mensaje_loading = "Descargando datos..."
          axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/datos-tabla-informe?fecha_inicio=' + this.fecha_inicio + '&fecha_fin=' + this.fecha_fin,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then((response) => {                  
              let myObject = response.data;
              this.data = myObject['recs']; 
              this.headers = myObject['columns']; 
              this.loading = false;     
          })



      },

    updateChart() {
      if (!this.chart) return;

      const series = this.selectedVariables.map((variable) => ({
        name: variable,
        type: this.chartType,
        data: this.data.map((d) => d[variable]),
      }));

      const option = {
        tooltip: { trigger: "axis" },
        legend: { data: this.selectedVariables },
        xAxis: {
          type: "category",
          data: this.data.map((d) => d.Hora),
        },
        yAxis: { type: "value" },
        series,
      };

      this.chart.setOption(option);
    },

  },
  created() {
    
  }
};*/
export default {
  mounted() {
    // Abre la URL en una nueva pestaña
    window.open("https://app.powerbi.com/groups/me/apps/ec572e34-7498-48a5-9055-4b15bc79bc80/reports/8e644d26-b258-4049-b2ea-d7890266bdd1/52635185cfb96eb462e6?language=es-ES&experience=power-bi/", "_blank");
  },
};
</script>



<style scoped>
.v-container {
  max-width: 800px;
}
</style>
